<form [formGroup]="wireDetailsForm" class="wire-details-wrapper">
  <rkt-form
    [form]="wireDetailsForm"
    [fields]="wireDetailsField"
    (modelChange)="onWireDetailsChange()"
    [model]="wireDetailsModel"
  ></rkt-form>
</form>
